import React from 'react'
import './DescriptionBox.css'

const DescriptionBox = () => {
  return (
    <div className='DescriptionBox'>
        <div className="description-boxNavigator">
            <div className="des-box-nav-box">Description</div>
            <div className="desc-box-nav-box-fade">REVIEWS (122)</div>
        </div>
        <div className="desc-box-desc">
            <p>"Discover the ultimate shopping experience at SHOPPER! From trendy fashion and must-have accessories to the latest gadgets and home essentials, we bring you a curated collection of high-quality products at unbeatable prices. Shop with confidence, enjoy seamless browsing, and let us deliver happiness right to your doorstep. Your satisfaction is our priority!"</p>
        <p></p>
        </div>
    </div>
  )
}

export default DescriptionBox